import React, { FC } from 'react'
import { SelectedPaymentMethod } from '../../model'
import { useBuildPaymentMethodProps } from './hooks'
import { isNullOrUndefined } from '@afterpay/utils'
import { PaymentMethodIcon } from '../PaymentMethodIcon'
import { PaymentMethodInfo } from './PaymentMethodInfo'
import { Heading } from '@afterpaytouch/core'
import styles from './style.module.css'

const Spacer: FC = () => <span />

interface PayWithInfoProps {
  paymentMethodDesc?: string
  cashTag?: string
  hasSeparator?: boolean
  expiryDate?: string
}

const PayWithInfo: FC<PayWithInfoProps> = ({ paymentMethodDesc, cashTag, hasSeparator, expiryDate }) => {
  return (
    <>
      <Spacer />
      <PaymentMethodInfo paymentMethodMasks={paymentMethodDesc} hasSeparator={hasSeparator} cashTag={cashTag} expiryDate={expiryDate} />
    </>
  )
}

export const PayWithSection: FC<{ selectedPaymentMethod?: SelectedPaymentMethod }> = ({ selectedPaymentMethod }) => {
  const props = useBuildPaymentMethodProps(selectedPaymentMethod)
  if (isNullOrUndefined(selectedPaymentMethod) || isNullOrUndefined(props)) {
    return null
  }
  const { paymentMethodName, iconType, paymentMethodDesc, cashTag, hasSeparator, expiryDate } = props
  return (
    <div className={styles.buttonContentContainer}>
      <PaymentMethodIcon size='Small' type={iconType} />
      <div className={styles.buttonContainer}>
        <Heading size='M' renderAs='span' testNameSpace='summary-select-payment-method'>
          {paymentMethodName}
        </Heading>
        <PayWithInfo paymentMethodDesc={paymentMethodDesc} cashTag={cashTag} hasSeparator={hasSeparator} expiryDate={expiryDate} />
      </div>
    </div>
  )
}
